import { inject_rb_form } from '../form';

const state_confg = inject_rb_form({
    url: '/sessions',
    reloadOnSearch: false,
    data: {
        title: 'Sessions',
        priority: 90,
    },
    views: {
        '': {
            template: require('./view.html'),
        },
    },
});
export default state_confg;
